module.exports = __webpack_public_path__ + "static/media/sf-test-4.d425fe3d.mp3";